import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../Header";
import Sidebar from "../Sidebar";
import ClickOutside from "../ClickOutside";

const DefaultLayout = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  // const [sidebarCollapsed, setSidebarCollapsed] = useState(
  //   localStorage.getItem("sidebar-expanded") === "true"
  // );
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(true);
  const navigate = useNavigate();

  // useEffect(() => {
  //   const authToken = sessionStorage.getItem("authToken");
  //   if (!authToken) {
  //     setIsLoggedIn(false);
  //     navigate("/signin");
  //   }
  // }, [navigate]);

  if (!isLoggedIn) {
    return null;
  }

  return (
    <div className="bg-gray">
      <div className="flex h-screen overflow-hidden">
        <Sidebar
          sidebarOpen={sidebarOpen}
          setSidebarOpen={setSidebarOpen}
          sidebarCollapsed={sidebarCollapsed}
          setSidebarCollapsed={setSidebarCollapsed}
        />
        <div className="relative flex flex-1 flex-col overflow-y-auto overflow-x-hidden">
          <Header
            sidebarOpen={sidebarOpen}
            setSidebarOpen={setSidebarOpen}
            sidebarCollapsed={sidebarCollapsed}
            setSidebarCollapsed={setSidebarCollapsed}
          />
          <div className="bg-gray flex flex-col min-h-full">
            <main className="">
              <div className="mx-auto md:p-4">{children}</div>
            </main>
            {/* Footer */}
            <footer className="flex justify-between items-center px-6 py-4 text-sm text-gray-500 border-t border-gray-200 bg-white">
              <div>2025 © CRM</div>
              <div className="text-right tracking-wide">
                Design & Develop by {""}
                <span className="font-semibold text-[#405189]">
                  MSM SOLUTION
                </span>
              </div>
            </footer>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DefaultLayout;
